module.exports = __webpack_public_path__ + "static/img/download.9dfb0ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/download.png
// module id = aHOS
// module chunks = 1